import React from 'react'

export default function BreadCrumbOwn({title}) {
  return (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '150px', backgroundImage: 'url(https://t4.ftcdn.net/jpg/02/67/83/01/360_F_267830184_8WBGurGYvqWhqWyCiceVGXBIIBosnOrl.jpg)', backgroundSize: 'fit', backgroundRepeat: 'no-repeat', backgroundColor: 'black'}}>
        <div style={{color: 'white', fontWeight: 700, fontSize: 18}}>{title}</div>
    </div>
  )
}
